import { render, staticRenderFns } from "./PUserEdit.vue?vue&type=template&id=4a7c51b4&"
import script from "./PUserEdit.vue?vue&type=script&lang=ts&"
export * from "./PUserEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports